export { default } from "./MultipleChoice";
